import { ThroughSchema } from "./ThroughSchema.js";
/** Validate a value of a specific type or `null`. */
export class OptionalSchema extends ThroughSchema {
    constructor({ value = null, ...options }) {
        super({ value, ...options });
    }
    validate(unsafeValue = this.value) {
        if (unsafeValue === null || unsafeValue === undefined || unsafeValue === "" || Number.isNaN(unsafeValue))
            return null;
        return super.validate(unsafeValue);
    }
}
/** Create a new optional schema from a source schema. */
export const OPTIONAL = (source) => new OptionalSchema({ source });
